



































































































import overlays from '@/mixins/overlays'
import wrappers from '@/mixins/wrappers'
import utils from '@/mixins/utils'
import mixins from 'vue-typed-mixins'
import {
  GroupedActivityItem,
  ActivityLevel,
  PainLevel,
  SleepLevel
} from '@/types/user/API/ReqRes/userActivity'
import ChronicPainMemo from '@components/modals/TrackChronicPainMemo.vue'
import HereToHelpMemo from '@components/modals/HereToHelpMemo.vue'
import { get, clone } from 'lodash'
import moment, { Moment } from 'moment-timezone'
import { User } from '@/types'
import eventTracker from '@/utils/eventTracker'
import { PropOptions } from 'vue'
type LogType = 'sleep' | 'pain' | 'activity'
type CardType = LogType | 'note'
type LevelKey = 'sleepLevel' | 'painLevel' | 'activityLevel'
export default mixins(overlays, wrappers, utils).extend({
  name: 'LogCard',
  props: {
    card: Object as PropOptions<GroupedActivityItem>
  },
  data () {
    return {
      get,
      note: '',
      type: 'sleep' as CardType,
      morningComplete: false,
      morningThreshold: 11,
      levels: ['green', 'orange', 'red'],
      labels: {
        sleep: {
          green: 'better',
          orange: 'same',
          red: 'worse'
        },
        pain: {
          green: 'less',
          orange: 'same',
          red: 'more'
        },
        activity: {
          green: 'more',
          orange: 'same',
          red: 'less'
        }
      },
      selected: null as string | null,
      cardBackup: {} as GroupedActivityItem
    }
  },
  computed: {
    wrapped (): Record<string, any> {
      return {
        submit: this.offlineWrapper(this.submit)
      }
    },
    trialTime (): User.TrialTime {
      return this.$store.getters['user/trialTime']
    },
    localDate (): Moment {
      return moment(this.card.localDate)
    },
    date (): string {
      return this.localDate.format('MMMM D, YYYY')
    },
    name (): string {
      return get(this.$store.getters['user/me'], 'firstName', '').trim()
    },
    title (): string {
      const day = this.$t('Track.Card.title.day')
      const diff = this.localDate.diff(this.trialTime.moments.start, 'days') + 1
      const note = this.trialTime.is(this.localDate).trialLastDay
        ? this.$t('Track.Card.title.lastDay')
        : this.localDate.calendar(this.trialTime.moments.today)
      return `${day} ${diff} (${note})`
    },
    isItMorning (): boolean {
      return this.isItForToday && moment().hours() <= this.morningThreshold
    },
    isItForToday (): boolean {
      return !this.card.fromToday
    },
    showBackButton (): boolean {
      return (this.type === 'pain' && !this.morningComplete) || this.type === 'activity'
    },
    commentType (): string {
      return `comment about your ${this.isItMorning && !this.morningComplete ? 'sleep' : 'pain'}`
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    type: {
      handler () {
        // if (this.type !== 'note') {
        this.$emit('typeUpdated', this.type)
        // }
      },
      immediate: true
    }
  },
  methods: {
    init () {
      this.cardBackup = clone(this.card)
      this.morningComplete =
        ['better', 'same', 'worse'].includes(this.card.sleepLevel as string) ||
        (this.card.sleepLevel === 'skip' && !!this.card.sleepNote)
      this.type = this.morningComplete ? 'pain' : 'sleep'
      this.updateCardState()
      this.$emit('backupUpdated', this.cardBackup)
    },
    getCardValues (): Record<CardType, string> {
      return ['sleep', 'pain', 'activity'].reduce(
        (acc, type) => {
          const key = `${type}Level` as keyof GroupedActivityItem
          return {
            ...acc,
            [type]: (this.card)[key]
          }
        }, {} as Record<CardType, string>
      )
    },
    updateCardState () {
      const cardValues = this.getCardValues()
      const levelValuePair = Object
        .entries(this.labels[this.type as LogType])
        .find(
          ([, value]) => value === cardValues[this.type]
        )
      this.selected = levelValuePair ? levelValuePair[0] : null
    },
    selectClicked (level: string, event: MouseEvent) {
      const target = event.currentTarget as HTMLButtonElement
      if (target) {
        target.blur()
      }
      this.select(level)
    },
    selectPressed (level: string, event: KeyboardEvent) {
      if ([13, 32].includes(event.keyCode)) {
        this.select(level)
        event.preventDefault()
      }
    },
    select (level: string) {
      // TODO: fix types
      type Level = 'green' | 'orange' | 'red'
      this.selected = this.selected === level ? null : level
      const card = clone(this.card) as any
      card[`${this.type}Level`] = this.selected
        ? this.labels[this.type as LogType][this.selected as Level]
        : null
      this.$emit('input', card)
    },
    getContainerClass (level: string) {
      return `
        container--${level}
        ${level === this.selected ? 'container--active' : ''}
      `
    },
    save (isItSkip = false) {
      return (event: MouseEvent) => {
        const target = event.target as HTMLButtonElement
        if (target) {
          target.blur()
        }
        // --
        const forwardMap = {
          sleep: this.isItMorning ? 'note' : 'pain',
          pain: 'activity',
          activity: 'note',
          note: 'note'
        } as Record<CardType, CardType>
        const value = isItSkip
          ? 'skip'
          : get(this.labels, `${this.type}.${this.selected}`)
        this.card[`${this.type}Level` as LevelKey] = value
        this.type = forwardMap[this.type]
        if (this.type !== 'note') {
          this.updateCardState()
        }
      }
    },
    back (event: MouseEvent) {
      const target = event.currentTarget as HTMLButtonElement
      if (target) {
        target.blur()
      }
      // --
      const backingMap = {
        sleep: 'sleep',
        pain: 'sleep',
        activity: 'pain',
        note: this.isItMorning && !this.morningComplete ? 'sleep' : 'activity'
      } as Record<CardType, CardType>
      this.type = backingMap[this.type]
      this.updateCardState()
    },
    async submit (event: MouseEvent) {
      const target = event.target as HTMLButtonElement
      if (target) {
        target.blur()
      }
      const activities = []
      const events: {
        pain?: Exclude<PainLevel, null>;
        activity?: Exclude<ActivityLevel, null>;
        sleep?: Exclude<SleepLevel, null>;
        comment?: string;
        when: 'am' | 'pm';
      }[] = []
      const activityTimestamp = this.isItForToday
        ? moment().valueOf()
        : this.localDate.valueOf()
      if (this.isItMorning && !this.morningComplete) {
        if (
          (!this.card.sleepLevel || this.card.sleepLevel === 'skip') && !this.note
        ) {
          // Can't proceed if everything is skipped
          await this.showModal(
            this.$t('Track.Card.prompt.skipped.morningMessage'),
            {
              title: this.$t('Track.Card.prompt.skipped.title')
            }
          )
          return
        }
        // morning only submission (for today)
        activities.push({
          type: 'Sleep',
          activityTimestamp,
          sleepLevel: this.card.sleepLevel,
          ...(this.note ? { note: this.note } : {})
        })
        if (this.card.sleepLevel) {
          events.push({
            sleep: this.card.sleepLevel,
            comment: this.note,
            when: 'am'
          })
        }
        this.card.sleepNote = this.note
        this.card.isComplete = false
      }
      else {
        const when = this.isItMorning ? 'am' : 'pm'
        if (this.card.painLevel === 'more') {
          await this.showHereToHelpMemo()
        }
        const requestCallback = this.card.requestCallback || false
        if (!this.morningComplete) {
          // Can't proceed if everything is skipped
          if (
            (!this.card.sleepLevel || this.card.sleepLevel === 'skip') &&
            (!this.card.painLevel || this.card.painLevel === 'skip') &&
            (!this.card.activityLevel || this.card.activityLevel === 'skip') &&
            !this.card.sleepNote &&
            !this.note
          ) {
            await this.showModal(
              this.$t('Track.Card.prompt.skipped.fullDayMessage'),
              {
                title: this.$t('Track.Card.prompt.skipped.title')
              }
            )
            return
          }
          // Add morning data
          activities.push({
            type: 'Sleep',
            sleepLevel: this.card.sleepLevel,
            activityTimestamp
          })
          if (this.card.sleepLevel) {
            events.push({
              sleep: this.card.sleepLevel,
              comment: this.note,
              when
            })
          }
        }
        else if (
          (!this.card.painLevel || this.card.painLevel === 'skip') &&
          (!this.card.activityLevel || this.card.activityLevel === 'skip') &&
          !this.note
        ) {
          await this.showModal(
            this.$t('Track.Card.prompt.skipped.afternoonMessage'),
            {
              title: this.$t('Track.Card.prompt.skipped.title')
            }
          )
          return
        }
        // add afternoon data
        activities.push({
          type: 'Pain',
          requestCallback,
          painLevel: this.card.painLevel,
          activityLevel: this.card.activityLevel,
          activityTimestamp,
          ...(this.note ? { note: this.note } : {})
        })
        if (this.card.painLevel && this.card.activityLevel) {
          events.push({
            pain: this.card.painLevel,
            activity: this.card.activityLevel,
            comment: this.note,
            when
          })
        }
        this.card.painNote = this.note
        this.card.isComplete = true
      }
      // Submit
      this.showSnackbar(this.$t('snackbars.logSent'), { timeout: 5000 })
      // Send all pending tracking events out
      events.forEach(eventData => {
        eventTracker.track('LogAdded', eventData)
      })
      // Update parent interface
      this.$emit('input', this.card)
      // Cleanup to continue with the same card
      if (!this.card.isComplete) {
        this.type = 'pain'
        this.selected = null
        this.morningComplete = true
        this.note = ''
      }
      try {
        await this.$store.dispatch('user/activities/CreateMany', activities)
        this.$emit('backupUpdated', this.card)
        this.cardBackup = clone(this.card)
      }
      catch (error) {
        Object.assign(this.card, clone(this.cardBackup))
        this.type = 'sleep'
        this.morningComplete = false
        this.selected = null
        this.note = ''
        this.$emit('input', this.card)
        throw error
      }
    },
    showChronicPainInfo (event: InputEvent) {
      const target = event.target as HTMLButtonElement
      if (target) {
        target.blur()
      }
      this.showModal({
        component: ChronicPainMemo,
        events: ['close']
      })
    },
    async showHereToHelpMemo () {
      const result = await this.showModal({
        component: HereToHelpMemo,
        events: ['yes', 'no']
      })
      if (result.action === 'yes') {
        this.$set(this.card, 'requestCallback', true)
      }
    }
  }
})
